import React from 'react';
import { useTranslation } from 'react-i18next';
import { P } from '../../../base/typography';
import UploadFiles from '../../../uploadFiles';
import { useMultiStepFormContext } from '../../context/multistepContext';
import { useTranslationsContext } from '../../context/translationsContext';
import { FormStepProps } from '../../sendReceiptMultistep';
import {
	ButtonWrapper,
	FormStepHeading,
	Label,
	PrevButton,
	PrevButtonMobile,
	ProceedButton,
} from '../../sendReceiptMultistep.styles';
import * as StyledInstructionToStaff from './InstructionToStaff.styles';

export default function SendUsInformation({ values, errors }: FormStepProps) {
	const translations = useTranslationsContext();
	const { next, prev } = useMultiStepFormContext();
	const { t } = useTranslation('sendReceiptMultistep');

	const isStepComplete = !errors.files && values.additionalInformation && !errors.additionalInformation;

	return (
		<>
			<PrevButtonMobile
				onClick={e => {
					e.stopPropagation();
					prev();
				}}>
				{translations?.prevStepMobile || t('prevStepMobile')}
			</PrevButtonMobile>
			<FormStepHeading>
				{translations?.formStepTitles?.type?.other || t('formStepTitles.type.other')}
			</FormStepHeading>
			<Label>{translations?.description || t('description')}*</Label>
			<StyledInstructionToStaff.TextArea
				maxLength="254"
				type="text"
				id="additionalInformation"
				name="additionalInformation"
				component="textarea"
				padding="1rem"
				placeholder={`${translations?.descriptionPlaceholder || t('descriptionPlaceholder')}`}
			/>
			<P marginTop="2rem">{translations?.validReceipt || t('validReceipt')}</P>
			<Label>{translations?.sendAFile || t('sendAFile')}</Label>
			<UploadFiles name="files" />
			<ButtonWrapper>
				<PrevButton
					onClick={e => {
						e.stopPropagation();
						prev();
					}}>
					{translations?.prevStep || t('prevStep')}
				</PrevButton>
				<ProceedButton
					type="button"
					onClick={e => {
						e.stopPropagation();
						next();
					}}
					disabled={!isStepComplete}
					marginTop="2rem">
					{translations?.nextStep || t('nextStep')}
				</ProceedButton>
			</ButtonWrapper>
		</>
	);
}
